import React, { useEffect, useRef } from 'react';
import Overlay from './Overlay';
import { Viewer } from 'photo-sphere-viewer';
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css';

interface PanoLightboxProps {
  src: string;
  onClose: () => void;
}

const PanoLightbox: React.FC<PanoLightboxProps> = ({ src, onClose }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;
    const viewer = new Viewer({
      container: containerRef.current,
      panorama: src,
      navbar: ['zoom', 'fullscreen'],
      defaultZoomLvl: 50,
      touchmoveTwoFingers: true,
    });

    return () => viewer?.destroy();
  }, [src]);

  return (
    <Overlay onClose={onClose}>
      <div ref={containerRef} className="w-full h-[70vh] rounded-lg overflow-hidden bg-black" />
    </Overlay>
  );
};

export default PanoLightbox;
